<template>
  <div>
    <van-pull-refresh v-if="total > 0"
                      v-model="isLoading"
                      :immediate-check="false"
                      @refresh="onRefresh">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
        <div class="decalare-con">
          <declare-list-item v-for="(item, index) in list"
                             v-bind:key="item.DeclareID"
                             @itemClickHandler="detailView(item)"
                             @downLoadHandler="downLoad(item)"
                             :isLast="index+1 === list.length"
                             :itemName="item.DeclareSujectName"
                             detailType="审批"
                             :fileState="item.DeclareFileState"
                             :deState="item.DeclareState"
                             :deStateName="item.DeclareStateName">
          </declare-list-item>
        </div>
      </van-list>
    </van-pull-refresh>
    <no-data v-else
             :needBg="true"
             class="footer"></no-data>
    <declare-detail :detail="detail"
                    :detailModel="detailModel"
                    @closeDetail="close"></declare-detail>
  </div>
</template>
<script>
import xyUtils from '@/common/utils'
import DeclareListItem from '@/pages/educationAffairs/components/DeclareListItem'
import DeclareDetail from '@/pages/educationAffairs/views/declare/DeclareApplyDetail'
import NoData from '@/components/noData/Index'

export default {
  name: 'DeclareApplyList',
  components: {
    DeclareListItem,
    DeclareDetail,
    NoData
  },
  data () {
    return {
      isLoading: false,//下拉刷新状态
      pageIndex: 1,
      pageSize: 15,
      loading: false,// 是否加载中
      finished: false,// 加载是否完成
      list: [],
      total: 0,
      detailModel: false,
      detail: {},//明细
    }
  },
  created () {
    this.onLoad();
  },
  mounted () {
  },
  methods: {
    async onLoad () {
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/Declare/GetAll`, {
        seachText: '',
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        declareState: 0
      })
      this.loading = false;
      if (res.success) {
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.list = [...this.list, ..._list];
        this.pageIndex++;
        this.finished = (this.list.length >= res.data.totalRecords) ? true : false
      } else {
        this.$toast.fail(res.msg);
      }
    },
    onRefresh () {
      setTimeout(() => {
        this.list = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    //查看明细
    detailView (item) {
      this.detailModel = true;
      this.detail = item;
    },
    close () {
      this.detailModel = false;
      this.onRefresh();
    },
    //下载
    downLoad (view) {
      xyUtils.downFile(`${this.$store.state.apiPath}/api/Declare/Download?file=${view.DeclareFile}&subjectName=${view.DeclareSujectName}`);
    }
  }
}
</script>
<style lang="less" scoped>
.decalare-con {
  padding: 40px 25px 0 68px;
  .decalare-item:last-child {
    .img-left::after {
      display: none;
    }
  }
}
</style>
